module.exports = __webpack_public_path__ + "assets/drops/stock/Mushroom.png";